import languages from "./languages.json";

export default languages;
